import angular from 'angular';
import template from './template.html';
import './style.scss';

export class CandidatesListItem {
    /* @ngInject */
    constructor($scope, $state) {
        this.$scope = $scope;
        this.$state = $state;
    }

    $onChanges() {
        this.$scope.candidate = this.candidate;
        this.candidatePageHref = this.getCandidatePageHref();
    }

    onCheckboxClick(value, candidate) {
        candidate.check = value;
        this.onCandidateSelect();
    }

    candidateClick() {
        this.onCandidateClick({candidate: this.candidate});
    }

    getCandidatePageHref() {
        return this.$state.href(this.candidatePageRoute, {
            talentID : this.candidate.talentID || this.candidate.talentId,
            feedbackFilterMode: this.feedbackFilterMode,
        });
    }
}

export const CandidatesListItemConfiguration = {
    template,
    bindings: {
        candidate: '<',
        candidatePageRoute: '@',
        onCandidateClick: '&',
        onCandidateSelect: '&',
        feedbackFilterMode: '<',
    },
    controller: CandidatesListItem,
    controllerAs: 'candidatesListItemCtrl'
};

angular.module('TALENYA-FE').component('candidatesListItem', CandidatesListItemConfiguration);
